import { combineEpics } from "redux-observable";

import * as UserEpics from './users';
import * as TrialEpics from './trials';
import * as TrialItemEpics from './trialItems';
import * as TrialGroupEpics from './trialGroups';
import * as TrialGroupItemEpics from './trialGroupItems';
import * as TrialInstitutionEpics from './trialInstitutions';
import * as TrialInstitutionItemEpics from './trialInstitutionItems';
import * as TrialPersonnelEpics from './trialPersonnels';
import * as ItemComponents from './itemComponents';
import * as CategoryEpics from './categories';
import * as GroupEpics from './groups';
import * as GroupItemTemplateEpics from './groupItemTemplates';
import * as GroupItemTemplateCategoryEpics from './groupItemTemplateCategorys';
import * as GroupContractEpics from './groupContract';
import * as GroupFinanceEpics from './groupFinance';
import * as CollectionEpics from './collections';
import * as InstitutionEpics from './institutions';
import * as CollectionInstanceEpics from './collectionInstances';
import * as PersonnelEpics from './personnel';
import * as PersonnelRoleEpics from './personnelRoles';
import * as SearchEpics from './search';
import * as CountryEpics from './countries';
import * as InstitutionCodingsEpics from './institutionCodings';
import * as NoteTypeEpics from './noteTypes';
import * as TrialTypeEpics from './trialTypes';
import * as ItemComponentTypeEpics from './itemComponentTypes';
import * as NoteEpics from './notes';
import * as TrialItemImportEpics from './trialItemImport';
import * as TrialItemUpdateEpics from './trialItemUpdate';
import * as OpenClinicaUserRolesEpics from './openClinicaUserRoles';
import * as StateEpics from './states';
import * as InstitutionTypeEpics from './institutionTypes';
import * as SiteLocationEpics from './siteLocations';
import * as KeyContactEpics from './keyContacts';
import * as MemberStatusesEpics from './memberStatuses';
import * as MembershipTypeEpics from './membershipTypes';
import * as ProfessionalDisciplineEpics from './professionalDisciplines';
import * as InterestEpics from './interests';
import * as SalutationEpics from './salutations';
import * as FormTemplateEpics from './formTemplates';
import * as RoleEpics from './roles';
import * as DepartmentEpics from './departments';
import * as DepartmentContactEpics from './departmentContacts';
import * as ReportingTagCategoryEpics from './reportingTagCategories';
import * as ReportingTagEpics from './reportingTags';
import * as TaskTypeEpics from './taskTypes';
import * as FormTemplateFileTypeEpics from './formTemplateFileTypes';
import * as TrackerTypeEpics from './trackerTypes';
import * as TrackerMilestoneEpics from './trackerMilestones';
import * as TrialDoiEpics from './trialDoi';
import * as TrialWebsiteEpics from './trialWebsite';
import * as StandardEmailTemplateEpics from './standardEmailTemplates';
import * as ProjectEpics from './projects';
import * as ProjectInvestigatorEpics from './projectInvestigators';
import * as DiscussionEpics from './discussions';
import * as ProjectItemsEpics from './projectItems';
import * as ProjectItemTemplateEpics from './projectItemTemplates';
import * as ProjectItemTemplateCategoryEpics from './projectItemTemplateCategorys';
import * as ProjectItemImportEpics from './projectItemImport';
import * as TrialInstitutionItemCustomViewEpics from './trialInstitutionItemCustomView';
import * as ParentTrialsEpics from './parentTrials';
import * as HrecEpics from './hrecs';
import * as HealthDistrictEpics from './healthDistricts';
import * as FellowshipEpics from './fellowships';
import * as CommitteeEpics from './committees';
import * as CommitteeMeetingEpics from './committeeMeetings';
import * as CommitteeRegularInviteeEpics from './committeeRegularInvitees';
import * as CommitteeMeetingAttendanceEpics from './committeeMeetingAttendances';
import * as CommitteeMemberEpics from './committeeMembers';
import * as CommitteeMemberRoleEpics from './committeeMemberRoles';
import * as GroupItemsEpics from './groupItems';
import * as ProjectedAccrualEpics from './projectedAccrual';
import * as AccrualANZEpics from './accrualANZ';
import * as LaboratoryEpics from './laboratories';
import * as LaboratoryDepartmentEpics from './laboratoryDepartments';
import * as LaboratoryPersonnelEpics from './laboratoryPersonnels';
import * as InstitutionLaboratoryEpics from './institutionLaboratory';
import * as TrialInstitutionLaboratoryEpics from './trialInstitutionLaboratory';
import * as TrialGroupLaboratoryEpics from './trialGroupLaboratory';
import * as TrialInstitutionLaboratoryPersonnelEpics from './trialInstitutionLaboratoryPersonnels';
import * as TrialGroupLaboratoryPersonnelEpics from './trialGroupLaboratoryPersonnels';
import * as TrialItemTemplateEpics from './trialItemTemplates';
import * as PersonnelTrainingEpics from './personnelTraining';
import * as InstitutionProcedureEpics from './institutionProcedure';
import * as InstitutionFinanceEpics from './institutionFinance';
import * as InstitutionContractEpics from './institutionContract';
import * as InstitutionConfidentialityDeedEpics from './institutionConfidentialityDeed';
import * as LaboratoryFinanceEpics from './laboratoryFinance';
import * as LaboratoryContractEpics from './laboratoryContract';
import * as LaboratoryConfidentialityDeedEpics from './laboratoryConfidentialityDeed';
import * as GroupConfidentialityDeedEpics from './groupConfidentialityDeed';
import * as TrialFinanceEpics from './trialFinance';
import * as TrialInstitutionFinanceEpics from './trialInstitutionFinance';
import * as TrialInstitutionContractEpics from './trialInstitutionContract';
import * as TrialGroupFinanceEpics from './trialGroupFinance';
import * as TrialGroupContractEpics from './trialGroupContract';
import * as TrialInstitutionLaboratoryFinanceEpics from './trialInstitutionLaboratoryFinance';
import * as TrialInstitutionLaboratoryContractEpics from './trialInstitutionLaboratoryContract';
import * as TrialGroupLaboratoryFinanceEpics from './trialGroupLaboratoryFinance';
import * as TrialGroupLaboratoryContractEpics from './trialGroupLaboratoryContract';
import * as InstitutionItemTemplateCategoryEpics from './institutionItemTemplateCategories';
import * as InstitutionItemTemplateEpics from './institutionItemTemplates';
import * as InstitutionItemEpics from './institutionItems';
import * as TrialInstitutionItemTemplateCategoryEpics from './trialInstitutionItemTemplateCategories';
import * as TrialInstitutionItemTemplateEpics from './trialInstitutionItemTemplates';
import * as TrialGroupItemTemplateCategoryEpics from './trialGroupItemTemplateCategories';
import * as TrialGroupItemTemplateEpics from './trialGroupItemTemplates';
import * as TrialItemCategoryEpics from './trialItemCategory';
import * as NoteTypeNotesEpics from './noteTypeNotes';
import * as TrialInstitutionItemCategoryEpics from './trialInstitutionItemCategory';
import * as TrialGroupItemCategoryEpics from './trialGroupItemCategory';
import * as InstitutionItemCategoryEpics from './institutionItemCategory';
import * as InstitutionCodeEpics from './institutionCode';
import * as GroupItemCategoryEpics from './groupItemCategory';
import * as MonitoringEpics from './monitorings';
import * as MonitoringIssueEpics from './monitoringIssues';
import * as MonitorEpics from './monitors';
import * as MonitoringDocumentEpics from './monitoringDocuments';
import * as MonitoringIssueDocumentEpics from './monitoringIssueDocuments';
import * as PatientsEpics from './patients';
import * as QuillDocumentEpics from './quillDocument';
import * as QuillDocumentImageEpics from './quillDocumentImage';

export const rootEpic = combineEpics<any, any, any>(
    UserEpics.getUserEpic,
    UserEpics.setAuthenticatedUserInSentryEpic,
    UserEpics.clearUserEpic,
    TrialEpics.getTrialsEpic,
    TrialEpics.getTrialsByIdEpic,
    TrialEpics.createTrialEpic,
    TrialEpics.setTrialEpic,
    TrialEpics.validateTrialEpic,
    TrialItemEpics.getTrialItemsByTrialIdEpic,
    TrialItemEpics.getTrialItemByIdEpic,
    TrialItemEpics.createTrialItemEpic,
    TrialItemEpics.setTrialItemEpic,
    TrialGroupEpics.getTrialGroupsEpic,
    TrialGroupEpics.getTrialGroupsByIdEpic,
    TrialGroupEpics.getTrialGroupsByGroupIdEpic,
    TrialGroupEpics.getTrialGroupsByTrialIdEpic,
    TrialGroupEpics.createTrialGroupEpic,
    TrialGroupEpics.setTrialGroupEpic,
    TrialInstitutionEpics.getTrialInstitutionsEpic,
    TrialInstitutionEpics.getTrialInstitutionsByTrialIdEpic,
    TrialInstitutionEpics.getTrialInstitutionsByInstitutionIdEpic,
    TrialInstitutionEpics.getTrialInstitutionsByIdEpic,
    TrialInstitutionEpics.createTrialInstitutionEpic,
    TrialInstitutionEpics.setTrialInstitutionEpic,
    TrialInstitutionEpics.validateTrialInstitutionEpic,
    TrialPersonnelEpics.getTrialPersonnelsByIdEpic,
    TrialPersonnelEpics.getTrialPersonnelsByPersonnelIdEpic,
    TrialPersonnelEpics.getTrialPersonnelsByTrialIdEpic,
    TrialPersonnelEpics.getTrialPersonnelsByInstitutionIdEpic,
    TrialPersonnelEpics.getTrialPersonnelsByTrialInstitutionIdEpic,
    TrialPersonnelEpics.getTrialPersonnelsByTrialGroupIdEpic,
    TrialPersonnelEpics.getTrialPersonnelsByGroupIdEpic,
    TrialPersonnelEpics.createTrialPersonnelEpic,
    TrialPersonnelEpics.setTrialPersonnelEpic,
    TrialPersonnelEpics.validateTrialPersonnelEpic,
    DepartmentEpics.getDepartmentsEpic,
    DepartmentEpics.getDepartmentsByIdEpic,
    DepartmentEpics.createDepartmentEpic,
    DepartmentEpics.setDepartmentEpic,
    DepartmentContactEpics.getDepartmentContactsEpic,
    DepartmentContactEpics.getDepartmentContactsByIdEpic,
    DepartmentContactEpics.createDepartmentContactEpic,
    DepartmentContactEpics.setDepartmentContactEpic,
    TrialInstitutionItemEpics.getTrialInstitutionItemByIdEpic,
    TrialInstitutionItemEpics.getTrialInstitutionItemsByTrialInstitutionIdEpic,
    TrialInstitutionItemEpics.getTrialInstitutionItemsSiteClosureEpic,
    TrialInstitutionItemEpics.setTrialInstitutionItemEpic,
    TrialInstitutionItemEpics.createTrialInstitutionItemEpic,
    TrialGroupItemEpics.getTrialGroupItemByIdEpic,
    TrialGroupItemEpics.getTrialGroupItemsByTrialGroupIdEpic,
    TrialGroupItemEpics.setTrialGroupItemEpic,
    TrialGroupItemEpics.createTrialGroupItemEpic,
    ItemComponents.getItemComponentByIdEpic,
    ItemComponents.getItemComponentEpic,
    ItemComponents.createItemComponentEpic,
    ItemComponents.setItemComponentEpic,
    CategoryEpics.getCategoriesEpic,
    CategoryEpics.getCategoryByIdEpic,
    CategoryEpics.setCategoryEpic,
    CategoryEpics.createCategoryEpic,
    CategoryEpics.validateCategoryEpic,
    GroupEpics.getGroupsEpic,
    GroupEpics.getGroupByIdEpic,
    GroupEpics.createGroupEpic,
    GroupEpics.setGroupEpic,
    GroupEpics.validateGroupEpic,
    GroupItemTemplateEpics.getGroupItemTemplatesEpic,
    GroupItemTemplateEpics.getGroupItemTemplatesByIdEpic,
    GroupItemTemplateEpics.createGroupItemTemplateEpic,
    GroupItemTemplateEpics.setGroupItemTemplateEpic,
    GroupItemTemplateEpics.validateGroupItemTemplateEpic,
    GroupItemTemplateCategoryEpics.getGroupItemTemplateCategorysEpic,
    GroupItemTemplateCategoryEpics.getGroupItemTemplateCategoryByIdEpic,
    GroupItemTemplateCategoryEpics.setGroupItemTemplateCategoryEpic,
    GroupItemTemplateCategoryEpics.createGroupItemTemplateCategoryEpic,
    GroupItemTemplateCategoryEpics.validateGroupItemTemplateCategoryEpic,
    CollectionEpics.getCollectionsByIdEpic,
    CollectionEpics.createCollectionEpic,
    InstitutionEpics.getInstitutionsEpic,
    InstitutionEpics.getInstitutionByIdEpic,
    InstitutionEpics.createInstitutionEpic,
    InstitutionEpics.setInstitutionEpic,
    InstitutionEpics.validateInstitutionEpic,
    CollectionInstanceEpics.getCollectionInstanceByIdEpic,
    CollectionInstanceEpics.setCollectionInstanceEpic,
    PersonnelEpics.getPersonnelEpic,
    PersonnelEpics.getPersonnelByIdEpic,
    PersonnelEpics.createPersonnelEpic,
    PersonnelEpics.setPersonnelEpic,
    PersonnelEpics.validatePersonnelEpic,
    PersonnelEpics.getPersonnelPermissionsByIdEpic,
    PersonnelEpics.postPersonnelResendEmailEpic,
    PersonnelEpics.getPersonnelByRoleEpic,
    PersonnelEpics.personnelAdvancedSearchEpic,
    PersonnelEpics.personnelTMDRoleEpic,
    PersonnelEpics.personnelTMDTrialEpic,
    PersonnelEpics.personnelCategoryEpic,
    PersonnelEpics.personnelTrialGroupEpic,
    PersonnelRoleEpics.postPersonnelRoleResendEmailEpic,
    PersonnelRoleEpics.getPersonnelRolesByIdEpic,
    PersonnelRoleEpics.createPersonnelRoleEpic,
    PersonnelRoleEpics.setPersonnelRoleEpic,
    PersonnelRoleEpics.validatePersonnelRoleEpic,
    SearchEpics.searchEpic,
    CountryEpics.getCountriesEpic,
    CountryEpics.getCountryByIdEpic,
    CountryEpics.setCountryEpic,
    CountryEpics.createCountryEpic,
    CountryEpics.validateCountryEpic,
    InstitutionCodingsEpics.getInstitutionCodingsEpic,
    InstitutionCodingsEpics.getInstitutionCodingByIdEpic,
    InstitutionCodingsEpics.setInstitutionCodingEpic,
    InstitutionCodingsEpics.createInstitutionCodingEpic,
    InstitutionCodingsEpics.validateInstitutionCodingEpic,
    NoteTypeEpics.getNoteTypesEpic,
    NoteTypeEpics.getNoteTypeByIdEpic,
    NoteTypeEpics.setNoteTypeEpic,
    NoteTypeEpics.createNoteTypeEpic,
    NoteTypeEpics.validateNoteTypeEpic,
    TrialTypeEpics.getTrialTypesEpic,
    TrialTypeEpics.getTrialTypeByIdEpic,
    TrialTypeEpics.setTrialTypeEpic,
    TrialTypeEpics.createTrialTypeEpic,
    TrialTypeEpics.validateTrialTypeEpic,
    NoteEpics.getNoteByIdEpic,
    NoteEpics.createNoteEpic,
    NoteEpics.setNoteEpic,
    NoteEpics.validateNoteEpic,
    ItemComponentTypeEpics.getItemComponentTypesEpic,
    ItemComponentTypeEpics.getItemComponentTypeByIdEpic,
    ItemComponentTypeEpics.setItemComponentTypeEpic,
    ItemComponentTypeEpics.createItemComponentTypeEpic,
    ItemComponentTypeEpics.validateItemComponentTypeEpic,
    TrialItemImportEpics.setTrialItemImportEpic,
    TrialItemUpdateEpics.getTrialItemUpdateByIdEpic,
    TrialItemUpdateEpics.setTrialItemUpdateEpic,
    OpenClinicaUserRolesEpics.getOpenClinicaUserRolesEpic,
    OpenClinicaUserRolesEpics.setOpenClinicaUserRoleEpic,
    OpenClinicaUserRolesEpics.postOpenClinicaUserRoleChangeStatusEpic,
    OpenClinicaUserRolesEpics.postOpenClinicaUserRoleResendEmailEpic,
    OpenClinicaUserRolesEpics.postOpenClinicaUserRoleImportEpic,
    StateEpics.getStatesEpic,
    StateEpics.getStateByIdEpic,
    StateEpics.setStateEpic,
    StateEpics.createStateEpic,
    StateEpics.validateStateEpic,    
    InstitutionTypeEpics.getInstitutionTypesEpic,
    InstitutionTypeEpics.getInstitutionTypeByIdEpic,
    InstitutionTypeEpics.setInstitutionTypeEpic,
    InstitutionTypeEpics.createInstitutionTypeEpic,
    InstitutionTypeEpics.validateInstitutionTypeEpic,
    SiteLocationEpics.getSiteLocationsEpic,
    SiteLocationEpics.getSiteLocationByIdEpic,
    SiteLocationEpics.setSiteLocationEpic,
    SiteLocationEpics.createSiteLocationEpic,
    SiteLocationEpics.validateSiteLocationEpic,
    KeyContactEpics.getKeyContactsEpic,
    KeyContactEpics.getKeyContactByIdEpic,
    KeyContactEpics.setKeyContactEpic,
    KeyContactEpics.createKeyContactEpic,  
    KeyContactEpics.validateKeyContactEpic,
    MemberStatusesEpics.getMemberStatusesEpic,
    MembershipTypeEpics.getMembershipTypesEpic,
    MembershipTypeEpics.getMembershipTypeByIdEpic,
    MembershipTypeEpics.setMembershipTypeEpic,
    MembershipTypeEpics.createMembershipTypeEpic,  
    MembershipTypeEpics.validateMembershipTypeEpic,  
    ProfessionalDisciplineEpics.getProfessionalDisciplinesEpic,
    ProfessionalDisciplineEpics.getProfessionalDisciplineByIdEpic,
    ProfessionalDisciplineEpics.setProfessionalDisciplineEpic,
    ProfessionalDisciplineEpics.createProfessionalDisciplineEpic, 
    ProfessionalDisciplineEpics.validateProfessionalDisciplineEpic,   
    InterestEpics.getInterestsEpic,
    InterestEpics.getInterestByIdEpic,
    InterestEpics.setInterestEpic,
    InterestEpics.createInterestEpic,
    InterestEpics.validateInterestEpic,
    SalutationEpics.getSalutationsEpic,
    SalutationEpics.getSalutationByIdEpic,
    SalutationEpics.setSalutationEpic,
    SalutationEpics.createSalutationEpic,
    SalutationEpics.validateSalutationEpic,
    FormTemplateEpics.getFormTemplatesEpic,
    FormTemplateEpics.getFormTemplateByIdEpic,
    FormTemplateEpics.setFormTemplateEpic,
    FormTemplateEpics.createFormTemplateEpic,
    FormTemplateEpics.validateFormTemplateEpic,
    RoleEpics.getRolesEpic,
    RoleEpics.getRoleByIdEpic,
    RoleEpics.setRoleEpic,
    RoleEpics.createRoleEpic,
    RoleEpics.validateRoleEpic,
    ReportingTagCategoryEpics.getReportingTagCategorysEpic,
    ReportingTagCategoryEpics.getReportingTagCategoryByIdEpic,
    ReportingTagCategoryEpics.setReportingTagCategoryEpic,
    ReportingTagCategoryEpics.createReportingTagCategoryEpic,
    ReportingTagCategoryEpics.validateReportingTagCategoryEpic,
    ReportingTagEpics.getReportingTagsEpic,
    ReportingTagEpics.getReportingTagByIdEpic,
    ReportingTagEpics.setReportingTagEpic,
    ReportingTagEpics.createReportingTagEpic,
    ReportingTagEpics.validateReportingTagEpic,
    TaskTypeEpics.getTaskTypesEpic,
    TaskTypeEpics.getTaskTypeByIdEpic,
    TaskTypeEpics.setTaskTypeEpic,
    TaskTypeEpics.createTaskTypeEpic,
    TaskTypeEpics.validateTaskTypeEpic,
    FormTemplateFileTypeEpics.getFormTemplateFileTypesEpic,
    FormTemplateFileTypeEpics.getFormTemplateFileTypeByIdEpic,
    FormTemplateFileTypeEpics.setFormTemplateFileTypeEpic,
    FormTemplateFileTypeEpics.createFormTemplateFileTypeEpic,
    FormTemplateFileTypeEpics.validateFormTemplateFileTypeEpic,
    TrackerTypeEpics.getTrackerTypesEpic,
    TrackerTypeEpics.getTrackerTypeByIdEpic,
    TrackerTypeEpics.setTrackerTypeEpic,
    TrackerTypeEpics.createTrackerTypeEpic,
    TrackerTypeEpics.validateTrackerTypeEpic,
    TrackerMilestoneEpics.getTrackerMilestonesEpic,
    TrackerMilestoneEpics.getTrackerMilestoneByIdEpic,
    TrackerMilestoneEpics.setTrackerMilestoneEpic,
    TrackerMilestoneEpics.createTrackerMilestoneEpic,
    TrackerMilestoneEpics.validateTrackerMilestoneEpic,
    TrialDoiEpics.getTrialDoiByTrialIdEpic,
    TrialDoiEpics.getTrialDoiByIdEpic,
    TrialDoiEpics.setTrialDoiEpic,
    TrialDoiEpics.createTrialDoiEpic,
    TrialDoiEpics.validateTrialDoiEpic,
    TrialWebsiteEpics.getTrialWebsiteByTrialIdEpic,
    TrialWebsiteEpics.getTrialWebsiteByIdEpic,
    TrialWebsiteEpics.setTrialWebsiteEpic,
    TrialWebsiteEpics.createTrialWebsiteEpic,
    TrialWebsiteEpics.validateTrialWebsiteEpic,
    StandardEmailTemplateEpics.getStandardEmailTemplatesEpic,
    StandardEmailTemplateEpics.getStandardEmailTemplateByIdEpic,
    StandardEmailTemplateEpics.setStandardEmailTemplateEpic,
    StandardEmailTemplateEpics.createStandardEmailTemplateEpic,
    StandardEmailTemplateEpics.validateStandardEmailTemplateEpic,
    ProjectEpics.getProjectsEpic,
    ProjectEpics.getProjectsByIdEpic,
    ProjectEpics.createProjectEpic,
    ProjectEpics.setProjectEpic,
    ProjectEpics.validateProjectEpic,
    ProjectInvestigatorEpics.getProjectInvestigatorsByIdEpic,
    ProjectInvestigatorEpics.getProjectInvestigatorsByProjectIdEpic,
    ProjectInvestigatorEpics.createProjectInvestigatorEpic,
    ProjectInvestigatorEpics.setProjectInvestigatorEpic,
    ProjectInvestigatorEpics.validateProjectInvestigatorEpic,
    DiscussionEpics.getDiscussionsEpic,
    DiscussionEpics.getDiscussionsByIdEpic,
    DiscussionEpics.createDiscussionEpic,
    DiscussionEpics.setDiscussionEpic,
    DiscussionEpics.validateDiscussionEpic,
    ProjectItemsEpics.getProjectItemsByProjectIdEpic,
    ProjectItemsEpics.setProjectItemEpic,
    ProjectItemsEpics.createProjectItemEpic,
    ProjectItemTemplateEpics.getProjectItemTemplatesEpic,
    ProjectItemTemplateEpics.getProjectItemTemplateByIdEpic,
    ProjectItemTemplateEpics.setProjectItemTemplateEpic,
    ProjectItemTemplateEpics.createProjectItemTemplateEpic,
    ProjectItemTemplateEpics.validateProjectItemTemplateEpic,
    ProjectItemTemplateCategoryEpics.getProjectItemTemplateCategorysEpic,
    ProjectItemTemplateCategoryEpics.getProjectItemTemplateCategoryByIdEpic,
    ProjectItemTemplateCategoryEpics.setProjectItemTemplateCategoryEpic,
    ProjectItemTemplateCategoryEpics.createProjectItemTemplateCategoryEpic,
    ProjectItemTemplateCategoryEpics.validateProjectItemTemplateCategoryEpic,
    ProjectItemImportEpics.getProjectItemImportByIdEpic,
    ProjectItemImportEpics.setProjectItemImportEpic,
    TrialInstitutionItemCustomViewEpics.getTrialInstitutionItemCustomViewsEpic,
    TrialInstitutionItemCustomViewEpics.createTrialInstitutionItemCustomViewEpic,
    TrialInstitutionItemCustomViewEpics.getTrialInstitutionItemCustomViewByIdEpic,
    TrialInstitutionItemCustomViewEpics.getTrialInstitutionItemCustomViewDataEntryByIdEpic,
    TrialInstitutionItemCustomViewEpics.setTrialInstitutionItemCustomViewEpic,
    TrialInstitutionItemCustomViewEpics.setTrialInstitutionItemCustomViewDataEntryEpic,
    ParentTrialsEpics.getParentTrialsEpic,
    HrecEpics.getHrecsEpic,
    HrecEpics.getHrecsByIdEpic,
    HrecEpics.createHrecEpic,
    HrecEpics.setHrecEpic,
    HrecEpics.validateHrecEpic,
    HealthDistrictEpics.getHealthDistrictsEpic,
    HealthDistrictEpics.getHealthDistrictsByIdEpic,
    HealthDistrictEpics.createHealthDistrictEpic,
    HealthDistrictEpics.setHealthDistrictEpic,
    HealthDistrictEpics.validateHealthDistrictEpic,
    FellowshipEpics.getFellowshipsEpic,
    FellowshipEpics.getFellowshipsByIdEpic,
    FellowshipEpics.getFellowshipsByPersonnelIdEpic,
    FellowshipEpics.createFellowshipEpic,
    FellowshipEpics.setFellowshipEpic,
    FellowshipEpics.validateFellowshipEpic,
    CommitteeEpics.getCommitteesEpic,
    CommitteeEpics.getCommitteeByIdEpic,
    CommitteeEpics.createCommitteeEpic,
    CommitteeEpics.setCommitteeEpic,
    CommitteeEpics.validateCommitteeEpic,
    CommitteeMeetingEpics.getCommitteeMeetingsEpic,
    CommitteeMeetingEpics.getCommitteeMeetingsByIdEpic,
    CommitteeMeetingEpics.getCommitteeMeetingsByCommitteeIdEpic,
    CommitteeMeetingEpics.createCommitteeMeetingEpic,
    CommitteeMeetingEpics.setCommitteeMeetingEpic,
    CommitteeMeetingEpics.validateCommitteeMeetingEpic,
    CommitteeRegularInviteeEpics.getCommitteeRegularInviteesEpic,
    CommitteeRegularInviteeEpics.getCommitteeRegularInviteesByIdEpic,
    CommitteeRegularInviteeEpics.getCommitteeRegularInviteesByCommitteeIdEpic,
    CommitteeRegularInviteeEpics.createCommitteeRegularInviteeEpic,
    CommitteeRegularInviteeEpics.setCommitteeRegularInviteeEpic,
    CommitteeRegularInviteeEpics.validateCommitteeRegularInviteeEpic,
    CommitteeMeetingAttendanceEpics.getCommitteeMeetingAttendancesEpic,
    CommitteeMeetingAttendanceEpics.getCommitteeMeetingAttendancesByIdEpic,
    CommitteeMeetingAttendanceEpics.getCommitteeMeetingAttendancesByCommitteeMeetingIdEpic,
    CommitteeMeetingAttendanceEpics.createCommitteeMeetingAttendanceEpic,
    CommitteeMeetingAttendanceEpics.setCommitteeMeetingAttendanceEpic,
    CommitteeMeetingAttendanceEpics.validateCommitteeMeetingAttendanceEpic,
    CommitteeMemberEpics.getCommitteeMembersEpic,
    CommitteeMemberEpics.getCommitteeMembersByIdEpic,
    CommitteeMemberEpics.getCommitteeMembersByCommitteeIdEpic,
    CommitteeMemberEpics.createCommitteeMemberEpic,
    CommitteeMemberEpics.setCommitteeMemberEpic,
    CommitteeMemberEpics.validateCommitteeMemberEpic,
    CommitteeMemberRoleEpics.getCommitteeMemberRolesEpic,
    CommitteeMemberRoleEpics.getCommitteeMemberRolesByIdEpic,
    CommitteeMemberRoleEpics.getCommitteeMemberRolesByCommitteeIdEpic,
    CommitteeMemberRoleEpics.getCommitteeMemberRolesByPersonnelIdEpic,
    CommitteeMemberRoleEpics.createCommitteeMemberRoleEpic,
    CommitteeMemberRoleEpics.setCommitteeMemberRoleEpic,
    CommitteeMemberRoleEpics.validateCommitteeMemberRoleEpic,
    GroupItemsEpics.getGroupItemByIdEpic,
    GroupItemsEpics.getGroupItemsByGroupIdEpic,
    GroupItemsEpics.setGroupItemEpic,
    GroupItemsEpics.createGroupItemEpic,
    ProjectedAccrualEpics.getProjectedAccrualByTrialIdEpic,
    ProjectedAccrualEpics.getProjectedAccrualByIdEpic,
    ProjectedAccrualEpics.setProjectedAccrualEpic,
    ProjectedAccrualEpics.updateProjectedAccrualEpic,
    AccrualANZEpics.getAccrualANZByTrialIdEpic,
    AccrualANZEpics.getAccrualANZByIdEpic,
    LaboratoryEpics.getLaboratoriesEpic,
    LaboratoryEpics.getLaboratoryByIdEpic,
    LaboratoryEpics.createLaboratoryEpic,
    LaboratoryEpics.setLaboratoryEpic,
    LaboratoryEpics.validateLaboratoryEpic,
    LaboratoryDepartmentEpics.getLaboratoryDepartmentsEpic,
    LaboratoryDepartmentEpics.getLaboratoryDepartmentByIdEpic,
    LaboratoryDepartmentEpics.getLaboratoryDepartmentsByLaboratoryIdEpic,
    LaboratoryDepartmentEpics.createLaboratoryDepartmentEpic,
    LaboratoryDepartmentEpics.setLaboratoryDepartmentEpic,
    LaboratoryDepartmentEpics.deleteLaboratoryDepartmentEpic,
    LaboratoryDepartmentEpics.validateLaboratoryDepartmentEpic,
    LaboratoryPersonnelEpics.getLaboratoryPersonnelsEpic,
    LaboratoryPersonnelEpics.getLaboratoryPersonnelByIdEpic,
    LaboratoryPersonnelEpics.getLaboratoryPersonnelByLaboratoryIdEpic,
    LaboratoryPersonnelEpics.createLaboratoryPersonnelEpic,
    LaboratoryPersonnelEpics.setLaboratoryPersonnelEpic,
    LaboratoryPersonnelEpics.validateLaboratoryPersonnelEpic,
    InstitutionLaboratoryEpics.getInstitutionLaboratoriesEpic,
    InstitutionLaboratoryEpics.getInstitutionLaboratoryByIdEpic,
    InstitutionLaboratoryEpics.getInstitutionLaboratoryByLaboratoryIdEpic,
    InstitutionLaboratoryEpics.getInstitutionLaboratoryByInstitutionIdEpic,
    InstitutionLaboratoryEpics.createInstitutionLaboratoryEpic,
    InstitutionLaboratoryEpics.setInstitutionLaboratoryEpic,
    InstitutionLaboratoryEpics.deleteInstitutionLaboratoryEpic,
    InstitutionLaboratoryEpics.validateInstitutionLaboratoryEpic,
    TrialInstitutionLaboratoryEpics.getTrialInstitutionLaboratoriesEpic,
    TrialInstitutionLaboratoryEpics.getTrialInstitutionLaboratoriesByTrialInstitutionIdEpic,
    TrialInstitutionLaboratoryEpics.getTrialInstitutionLaboratoriesByTrialIdEpic,
    TrialInstitutionLaboratoryEpics.getTrialInstitutionLaboratoryByIdEpic,
    TrialInstitutionLaboratoryEpics.getTrialInstitutionLaboratoryByLaboratoryIdEpic,
    TrialInstitutionLaboratoryEpics.createTrialInstitutionLaboratoryEpic,
    TrialInstitutionLaboratoryEpics.setTrialInstitutionLaboratoryEpic,
    TrialInstitutionLaboratoryEpics.deleteTrialInstitutionLaboratoryEpic,
    TrialInstitutionLaboratoryEpics.validateTrialInstitutionLaboratoryEpic,
    TrialGroupLaboratoryEpics.getTrialGroupLaboratoriesEpic,
    TrialGroupLaboratoryEpics.getTrialGroupLaboratoriesByTrialGroupIdEpic,
    TrialGroupLaboratoryEpics.getTrialGroupLaboratoriesByTrialIdEpic,
    TrialGroupLaboratoryEpics.getTrialGroupLaboratoryByIdEpic,
    TrialGroupLaboratoryEpics.getTrialGroupLaboratoryByLaboratoryIdEpic,
    TrialGroupLaboratoryEpics.createTrialGroupLaboratoryEpic,
    TrialGroupLaboratoryEpics.setTrialGroupLaboratoryEpic,
    TrialGroupLaboratoryEpics.deleteTrialGroupLaboratoryEpic,
    TrialGroupLaboratoryEpics.validateTrialGroupLaboratoryEpic,
    TrialInstitutionLaboratoryPersonnelEpics.getTrialInstitutionLaboratoryPersonnelsEpic,
    TrialInstitutionLaboratoryPersonnelEpics.getTrialInstitutionLaboratoryPersonnelByIdEpic,
    TrialInstitutionLaboratoryPersonnelEpics.getTrialInstitutionLaboratoryPersonnelByLaboratoryIdEpic,
    TrialInstitutionLaboratoryPersonnelEpics.createTrialInstitutionLaboratoryPersonnelEpic,
    TrialInstitutionLaboratoryPersonnelEpics.setTrialInstitutionLaboratoryPersonnelEpic,
    TrialInstitutionLaboratoryPersonnelEpics.validateTrialInstitutionLaboratoryPersonnelEpic,
    TrialGroupLaboratoryPersonnelEpics.getTrialGroupLaboratoryPersonnelsEpic,
    TrialGroupLaboratoryPersonnelEpics.getTrialGroupLaboratoryPersonnelByIdEpic,
    TrialGroupLaboratoryPersonnelEpics.getTrialGroupLaboratoryPersonnelByLaboratoryIdEpic,
    TrialGroupLaboratoryPersonnelEpics.createTrialGroupLaboratoryPersonnelEpic,
    TrialGroupLaboratoryPersonnelEpics.setTrialGroupLaboratoryPersonnelEpic,
    TrialGroupLaboratoryPersonnelEpics.validateTrialGroupLaboratoryPersonnelEpic,
    TrialItemTemplateEpics.getTrialItemTemplatesEpic,
    TrialItemTemplateEpics.getTrialItemTemplatesByIdEpic,
    TrialItemTemplateEpics.createTrialItemTemplateEpic,
    TrialItemTemplateEpics.setTrialItemTemplateEpic,
    TrialItemTemplateEpics.validateTrialItemTemplateEpic,
    PersonnelTrainingEpics.getPersonnelTrainingByIdEpic,
    PersonnelTrainingEpics.getPersonnelTrainingsByPersonnelIdEpic,
    PersonnelTrainingEpics.createPersonnelTrainingEpic,
    PersonnelTrainingEpics.setPersonnelTrainingEpic,
    PersonnelTrainingEpics.validatePersonnelTrainingEpic,
    InstitutionProcedureEpics.getInstitutionProceduresByInstitutionIdEpic,
    InstitutionProcedureEpics.getInstitutionProcedureByIdEpic,
    InstitutionProcedureEpics.setInstitutionProcedureEpic,
    InstitutionProcedureEpics.createInstitutionProcedureEpic,
    InstitutionProcedureEpics.validateInstitutionProcedureEpic,
    InstitutionFinanceEpics.getInstitutionFinanceByInstitutionIdEpic,
    InstitutionFinanceEpics.getInstitutionFinanceByIdEpic,
    InstitutionFinanceEpics.setInstitutionFinanceEpic,
    InstitutionFinanceEpics.createInstitutionFinanceEpic,
    InstitutionFinanceEpics.validateInstitutionFinanceEpic,
    InstitutionContractEpics.getInstitutionContractByInstitutionIdEpic,
    InstitutionContractEpics.getInstitutionContractByIdEpic,
    InstitutionContractEpics.setInstitutionContractEpic,
    InstitutionContractEpics.createInstitutionContractEpic,
    InstitutionContractEpics.validateInstitutionContractEpic,
    InstitutionConfidentialityDeedEpics.getInstitutionConfidentialityDeedByInstitutionIdEpic,
    InstitutionConfidentialityDeedEpics.getInstitutionConfidentialityDeedByIdEpic,
    InstitutionConfidentialityDeedEpics.setInstitutionConfidentialityDeedEpic,
    InstitutionConfidentialityDeedEpics.createInstitutionConfidentialityDeedEpic,
    InstitutionConfidentialityDeedEpics.deleteInstitutionConfidentialityDeedEpic,
    InstitutionConfidentialityDeedEpics.validateInstitutionConfidentialityDeedEpic,
    LaboratoryFinanceEpics.getLaboratoryFinanceByLaboratoryIdEpic,
    LaboratoryFinanceEpics.getLaboratoryFinanceByIdEpic,
    LaboratoryFinanceEpics.setLaboratoryFinanceEpic,
    LaboratoryFinanceEpics.createLaboratoryFinanceEpic,
    LaboratoryFinanceEpics.validateLaboratoryFinanceEpic,
    LaboratoryContractEpics.getLaboratoryContractByLaboratoryIdEpic,
    LaboratoryContractEpics.getLaboratoryContractByIdEpic,
    LaboratoryContractEpics.setLaboratoryContractEpic,
    LaboratoryContractEpics.createLaboratoryContractEpic,
    LaboratoryContractEpics.validateLaboratoryContractEpic,
    LaboratoryConfidentialityDeedEpics.getLaboratoryConfidentialityDeedByLaboratoryIdEpic,
    LaboratoryConfidentialityDeedEpics.getLaboratoryConfidentialityDeedByIdEpic,
    LaboratoryConfidentialityDeedEpics.setLaboratoryConfidentialityDeedEpic,
    LaboratoryConfidentialityDeedEpics.createLaboratoryConfidentialityDeedEpic,
    LaboratoryConfidentialityDeedEpics.deleteLaboratoryConfidentialityDeedEpic,
    LaboratoryConfidentialityDeedEpics.validateLaboratoryConfidentialityDeedEpic,
    GroupFinanceEpics.getGroupFinanceByGroupIdEpic,
    GroupFinanceEpics.getGroupFinanceByIdEpic,
    GroupFinanceEpics.setGroupFinanceEpic,
    GroupFinanceEpics.createGroupFinanceEpic,
    GroupFinanceEpics.validateGroupFinanceEpic,
    GroupConfidentialityDeedEpics.getGroupConfidentialityDeedByGroupIdEpic,
    GroupConfidentialityDeedEpics.getGroupConfidentialityDeedByIdEpic,
    GroupConfidentialityDeedEpics.setGroupConfidentialityDeedEpic,
    GroupConfidentialityDeedEpics.createGroupConfidentialityDeedEpic,
    GroupConfidentialityDeedEpics.deleteGroupConfidentialityDeedEpic,
    GroupConfidentialityDeedEpics.validateGroupConfidentialityDeedEpic,
    GroupContractEpics.getGroupContractByGroupIdEpic,
    GroupContractEpics.getGroupContractByIdEpic,
    GroupContractEpics.setGroupContractEpic,
    GroupContractEpics.createGroupContractEpic,
    GroupContractEpics.validateGroupContractEpic,
    TrialFinanceEpics.getTrialFinanceByTrialIdEpic,
    TrialFinanceEpics.getTrialFinanceByIdEpic,
    TrialFinanceEpics.setTrialFinanceEpic,
    TrialFinanceEpics.createTrialFinanceEpic,
    TrialFinanceEpics.validateTrialFinanceEpic,
    TrialInstitutionFinanceEpics.getTrialInstitutionFinanceByTrialInstitutionIdEpic,
    TrialInstitutionFinanceEpics.getTrialInstitutionFinanceByIdEpic,
    TrialInstitutionFinanceEpics.setTrialInstitutionFinanceEpic,
    TrialInstitutionFinanceEpics.createTrialInstitutionFinanceEpic,
    TrialInstitutionFinanceEpics.validateTrialInstitutionFinanceEpic,
    TrialInstitutionContractEpics.getTrialInstitutionContractByTrialInstitutionIdEpic,
    TrialInstitutionContractEpics.getTrialInstitutionContractByIdEpic,
    TrialInstitutionContractEpics.setTrialInstitutionContractEpic,
    TrialInstitutionContractEpics.createTrialInstitutionContractEpic,
    TrialInstitutionContractEpics.validateTrialInstitutionContractEpic,
    TrialInstitutionContractEpics.deleteTrialInstitutionContractEpic,
    TrialGroupFinanceEpics.getTrialGroupFinanceByTrialGroupIdEpic,
    TrialGroupFinanceEpics.getTrialGroupFinanceByIdEpic,
    TrialGroupFinanceEpics.setTrialGroupFinanceEpic,
    TrialGroupFinanceEpics.createTrialGroupFinanceEpic,
    TrialGroupFinanceEpics.validateTrialGroupFinanceEpic,
    TrialGroupContractEpics.getTrialGroupContractByTrialGroupIdEpic,
    TrialGroupContractEpics.getTrialGroupContractByIdEpic,
    TrialGroupContractEpics.setTrialGroupContractEpic,
    TrialGroupContractEpics.createTrialGroupContractEpic,
    TrialGroupContractEpics.validateTrialGroupContractEpic,
    TrialGroupContractEpics.deleteTrialGroupContractEpic,
    TrialInstitutionLaboratoryFinanceEpics.getTrialInstitutionLaboratoryFinanceByTrialInstitutionLaboratoryIdEpic,
    TrialInstitutionLaboratoryFinanceEpics.getTrialInstitutionLaboratoryFinanceByIdEpic,
    TrialInstitutionLaboratoryFinanceEpics.setTrialInstitutionLaboratoryFinanceEpic,
    TrialInstitutionLaboratoryFinanceEpics.createTrialInstitutionLaboratoryFinanceEpic,
    TrialInstitutionLaboratoryFinanceEpics.validateTrialInstitutionLaboratoryFinanceEpic,
    TrialInstitutionLaboratoryContractEpics.getTrialInstitutionLaboratoryContractByTrialInstitutionLaboratoryIdEpic,
    TrialInstitutionLaboratoryContractEpics.getTrialInstitutionLaboratoryContractByIdEpic,
    TrialInstitutionLaboratoryContractEpics.setTrialInstitutionLaboratoryContractEpic,
    TrialInstitutionLaboratoryContractEpics.createTrialInstitutionLaboratoryContractEpic,
    TrialInstitutionLaboratoryContractEpics.validateTrialInstitutionLaboratoryContractEpic,
    TrialInstitutionLaboratoryContractEpics.deleteTrialInstitutionLaboratoryContractEpic,
    TrialGroupLaboratoryFinanceEpics.getTrialGroupLaboratoryFinanceByTrialGroupLaboratoryIdEpic,
    TrialGroupLaboratoryFinanceEpics.getTrialGroupLaboratoryFinanceByIdEpic,
    TrialGroupLaboratoryFinanceEpics.setTrialGroupLaboratoryFinanceEpic,
    TrialGroupLaboratoryFinanceEpics.createTrialGroupLaboratoryFinanceEpic,
    TrialGroupLaboratoryFinanceEpics.validateTrialGroupLaboratoryFinanceEpic,
    TrialGroupLaboratoryContractEpics.getTrialGroupLaboratoryContractByTrialGroupLaboratoryIdEpic,
    TrialGroupLaboratoryContractEpics.getTrialGroupLaboratoryContractByIdEpic,
    TrialGroupLaboratoryContractEpics.setTrialGroupLaboratoryContractEpic,
    TrialGroupLaboratoryContractEpics.createTrialGroupLaboratoryContractEpic,
    TrialGroupLaboratoryContractEpics.validateTrialGroupLaboratoryContractEpic,
    TrialGroupLaboratoryContractEpics.deleteTrialGroupLaboratoryContractEpic,
    InstitutionItemEpics.getInstitutionItemsByInstitutionIdEpic,
    InstitutionItemEpics.getInstitutionItemByIdEpic,
    InstitutionItemEpics.createInstitutionItemEpic,
    InstitutionItemEpics.setInstitutionItemEpic,
    InstitutionItemTemplateCategoryEpics.getInstitutionItemTemplateCategoriesEpic,
    InstitutionItemTemplateCategoryEpics.getInstitutionItemTemplateCategoryByIdEpic,
    InstitutionItemTemplateCategoryEpics.setInstitutionItemTemplateCategoryEpic,
    InstitutionItemTemplateCategoryEpics.createInstitutionItemTemplateCategoryEpic,
    InstitutionItemTemplateCategoryEpics.validateInstitutionItemTemplateCategoryEpic,
    InstitutionItemTemplateEpics.getInstitutionItemTemplatesEpic,
    InstitutionItemTemplateEpics.getInstitutionItemTemplatesByIdEpic,
    InstitutionItemTemplateEpics.createInstitutionItemTemplateEpic,
    InstitutionItemTemplateEpics.setInstitutionItemTemplateEpic,
    InstitutionItemTemplateEpics.validateInstitutionItemTemplateEpic,
    TrialInstitutionItemTemplateCategoryEpics.getTrialInstitutionItemTemplateCategoriesEpic,
    TrialInstitutionItemTemplateCategoryEpics.getTrialInstitutionItemTemplateCategoryByIdEpic,
    TrialInstitutionItemTemplateCategoryEpics.setTrialInstitutionItemTemplateCategoryEpic,
    TrialInstitutionItemTemplateCategoryEpics.createTrialInstitutionItemTemplateCategoryEpic,
    TrialInstitutionItemTemplateCategoryEpics.validateTrialInstitutionItemTemplateCategoryEpic,
    TrialInstitutionItemTemplateEpics.getTrialInstitutionItemTemplatesEpic,
    TrialInstitutionItemTemplateEpics.getTrialInstitutionItemTemplatesByIdEpic,
    TrialInstitutionItemTemplateEpics.createTrialInstitutionItemTemplateEpic,
    TrialInstitutionItemTemplateEpics.setTrialInstitutionItemTemplateEpic,
    TrialInstitutionItemTemplateEpics.validateTrialInstitutionItemTemplateEpic,
    TrialGroupItemTemplateCategoryEpics.getTrialGroupItemTemplateCategoriesEpic,
    TrialGroupItemTemplateCategoryEpics.getTrialGroupItemTemplateCategoryByIdEpic,
    TrialGroupItemTemplateCategoryEpics.setTrialGroupItemTemplateCategoryEpic,
    TrialGroupItemTemplateCategoryEpics.createTrialGroupItemTemplateCategoryEpic,
    TrialGroupItemTemplateCategoryEpics.validateTrialGroupItemTemplateCategoryEpic,
    TrialGroupItemTemplateEpics.getTrialGroupItemTemplatesEpic,
    TrialGroupItemTemplateEpics.getTrialGroupItemTemplatesByIdEpic,
    TrialGroupItemTemplateEpics.createTrialGroupItemTemplateEpic,
    TrialGroupItemTemplateEpics.setTrialGroupItemTemplateEpic,
    TrialGroupItemTemplateEpics.validateTrialGroupItemTemplateEpic,
    TrialItemCategoryEpics.getTrialItemCategoriesByTrialIdEpic,
    NoteTypeNotesEpics.getNoteTypeNotesByTrialIdEpic,
    NoteTypeNotesEpics.getNoteTypeNotesByTrialInstitutionIdEpic,
    NoteTypeNotesEpics.getNoteTypeNotesByInstitutionIdEpic,
    NoteTypeNotesEpics.getNoteTypeNotesByPersonnelIdEpic,
    TrialInstitutionItemCategoryEpics.getTrialInstitutionItemCategoriesByTrialInstitutionIdEpic,
    TrialGroupItemCategoryEpics.getTrialGroupItemCategoriesByTrialGroupIdEpic,
    InstitutionItemCategoryEpics.getInstitutionItemCategoriesByInstitutionIdEpic,
    InstitutionCodeEpics.getInstitutionCodesEpic,
    InstitutionCodeEpics.getInstitutionCodeByIdEpic,
    InstitutionCodeEpics.getInstitutionCodeByInstitutionIdEpic,
    InstitutionCodeEpics.setInstitutionCodeEpic,
    InstitutionCodeEpics.createInstitutionCodeEpic,
    InstitutionCodeEpics.validateInstitutionCodeEpic,
    GroupItemCategoryEpics.getGroupItemCategoriesByGroupIdEpic,
    MonitoringEpics.getMonitoringsEpic,
    MonitoringEpics.getMonitoringsByTrialInstitutionIdEpic,
    MonitoringEpics.getMonitoringsByIdEpic,
    MonitoringEpics.createMonitoringEpic,
    MonitoringEpics.setMonitoringEpic,
    MonitoringEpics.validateMonitoringEpic,
    MonitoringIssueEpics.getMonitoringIssuesEpic,
    MonitoringIssueEpics.getMonitoringIssuesByMonitoringIdEpic,
    MonitoringIssueEpics.getMonitoringIssuesByIdEpic,
    MonitoringIssueEpics.createMonitoringIssueEpic,
    MonitoringIssueEpics.setMonitoringIssueEpic,
    MonitoringIssueEpics.validateMonitoringIssueEpic,
    MonitorEpics.getMonitorsEpic,
    MonitorEpics.getMonitorsByMonitoringIdEpic,
    MonitorEpics.getMonitorsByIdEpic,
    MonitorEpics.createMonitorEpic,
    MonitorEpics.setMonitorEpic,
    MonitorEpics.validateMonitorEpic,
    MonitoringDocumentEpics.getMonitoringDocumentsEpic,
    MonitoringDocumentEpics.getMonitoringDocumentsByMonitoringIdEpic,
    MonitoringDocumentEpics.getMonitoringDocumentsByIdEpic,
    MonitoringDocumentEpics.createMonitoringDocumentEpic,
    MonitoringDocumentEpics.setMonitoringDocumentEpic,
    MonitoringDocumentEpics.validateMonitoringDocumentEpic,
    MonitoringIssueDocumentEpics.getMonitoringIssueDocumentsEpic,
    MonitoringIssueDocumentEpics.getMonitoringIssueDocumentsByMonitoringIssueIdEpic,
    MonitoringIssueDocumentEpics.getMonitoringIssueDocumentsByIdEpic,
    MonitoringIssueDocumentEpics.createMonitoringIssueDocumentEpic,
    MonitoringIssueDocumentEpics.setMonitoringIssueDocumentEpic,
    MonitoringIssueDocumentEpics.validateMonitoringIssueDocumentEpic,
    PatientsEpics.getPatientByIdEpic,
    QuillDocumentEpics.getQuillDocumentByIdEpic,
    QuillDocumentEpics.getQuillDocumentByTypeAndPageEpic,
    QuillDocumentEpics.getQuillDocumentsBySearchEpic,
    QuillDocumentEpics.setQuillDocumentEpic,
    QuillDocumentEpics.createQuillDocumentEpic,
    QuillDocumentEpics.validateQuillDocumentEpic,
    QuillDocumentImageEpics.getQuillDocumentImageByIdEpic,
    QuillDocumentImageEpics.getQuillDocumentImageByQuillDocumentIdEpic,
    QuillDocumentImageEpics.setQuillDocumentImageEpic,
    QuillDocumentImageEpics.createQuillDocumentImageEpic
);